export default __webpack_public_path__ + "static/2-9172a374faf5f4a14a35ff53320c1f70.jpeg";